import { JsonTree } from "react-editable-json-tree";
import styles from "./JsonTreeEditor.module.scss";

const treeButton = (icon, label) => (
    <button
        aria-label={label}
        className={styles.treeBtn}
        title={label}
        type="button"
    >
        <i aria-hidden className={`fas fa-${icon}`} />
    </button>
);

/**
 * DS-styled wrapper around `react-editable-json-tree`.
 * Same behavior as legacy JsonEditor; visual tokens only.
 *
 * NB: button elements must stay plain `<button>` so the library can
 * `cloneElement` them and attach its own onClick handlers.
 */
/** Keep all object/array nodes expanded by default (matches Redirect visual mode). */
const alwaysExpanded = () => false;

const JsonTreeEditor = ({ value, onChange, className, ...props }) => {
    return (
        <div className={[styles.root, className].filter(Boolean).join(" ")}>
            <JsonTree
                addButtonElement={treeButton("check", "Confirm add")}
                cancelButtonElement={treeButton("times", "Cancel")}
                data={value}
                editButtonElement={treeButton("check", "Confirm edit")}
                minusMenuElement={treeButton("trash-alt", "Remove")}
                onFullyUpdate={onChange}
                plusMenuElement={treeButton("plus", "Add")}
                {...props}
                isCollapsed={alwaysExpanded}
            />
        </div>
    );
};

export default JsonTreeEditor;
